import { AppState } from 'core/redux/reducers';
import { useSelector } from 'react-redux';
import React from 'react';
import FormStepContainer from '../Components/FormStepContainer';
import { Column } from 'Components/Elements/Layouts';
// import { hot } from 'react-hot-loader/root'
import Summary from '../Components/Summary';
import BookingNextLoading from '../Components/BookingNextLoading';
import Box from 'Components/Box';
import { useTrans } from 'core/hooks';

function Step3Comp() {
  const trans = useTrans();
  const loading = useSelector((state: AppState) => state.booking.loading);

  return (
    <FormStepContainer id="book-step3" nextButtonLabel={trans('accept')}>
      <Column
        className="checkout__content__items checkout--right-border eb-booking-terms"
        size={['8-tablet']}
      >
        <BookingNextLoading hide={!loading} />
        <Box code="checkout_terms" />
      </Column>
      <Column
        className="checkout__content__summary checkout__content__items checkout--bg-blue"
        size={'4'}
      >
        <Summary />
      </Column>
    </FormStepContainer>
  );
}

// const Step3 =
//   process.env.NODE_ENV !== 'production' ? hot(Step3Comp) : Step3Comp;
export default Step3Comp;
